import React from "react";
import DoctorIcon from "../icons/DoctorIcon";

import { DESCRIPTION_COLOR, TERTIARY_COLOR } from "../constants/theme";

const Doctor = ({ doctor, selectedDoctor, setSelectedDoctor }) => {
  const handleSelection = () => {
    if (
      selectedDoctor &&
      (selectedDoctor?.doctor_email === doctor?.doctor_email ||
        selectedDoctor?.email === doctor?.email)
    ) {
      setSelectedDoctor(undefined);
    } else {
      setSelectedDoctor(doctor);
    }
  };

  return (
    <div className="col p-0">
      <div className="row w-100 mx-auto align-items-center justify-content-center">
        <div className="col-auto p-0">
          <div
            className="d-flex flex-column align-items-center justify-content-center"
            style={{
              // border: '1px solid rgb(203, 108, 230)',
              width: "100%",
              // padding: '20px',
              // borderRadius: '20px',
              // backgroundColor: 'rgb(250, 229, 255)',
              gap: "0px",
            }}
            onClick={() => handleSelection()}
          >
            <div
              className=""
              style={{
                width: "80px",
              }}
            >
              <DoctorIcon
                bgColor={
                  selectedDoctor?.doctor_email === doctor?.doctor_email ||
                  selectedDoctor?.email === doctor?.email
                    ? "rgb(220, 143, 241)"
                    : DESCRIPTION_COLOR
                }
                skinColor={
                  selectedDoctor?.doctor_email === doctor?.doctor_email ||
                  selectedDoctor?.email === doctor?.email
                    ? "rgb(247, 155, 104)"
                    : TERTIARY_COLOR
                }
                hairColor={
                  selectedDoctor?.doctor_email === doctor?.doctor_email ||
                  selectedDoctor?.email === doctor?.email
                    ? "rgb(63, 36, 99)"
                    : "rgb(110, 121, 125)"
                }
                shadeColor={
                  selectedDoctor?.doctor_email === doctor?.doctor_email ||
                  selectedDoctor?.email === doctor?.email
                    ? "rgb(244, 113, 109)"
                    : DESCRIPTION_COLOR
                }
              />
            </div>

            <div
              className="text-center"
              style={{
                fontSize: "14.5px",
                color: "rgb(203, 108, 230)",
                fontWeight:
                  selectedDoctor?.doctor_email === doctor?.doctor_email ||
                  selectedDoctor?.email === doctor?.email
                    ? "600"
                    : "400",
                // lineHeight: "1.5",
                // minHeight: '60px'
              }}
            >
              {doctor?.name}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Doctor;
